/**
 * Airport Official Provider
 * Uses the Supabase edge function proxy to fetch from curated airport official sources.
 * Fails gracefully if the airport isn't in the curated mapping.
 */
import { WaitTimeProvider, ProviderResponse, FLAGS } from '../types';

const TIMEOUT_MS = 3000;

export const airportSiteProvider: WaitTimeProvider = {
  name: 'airport_official',

  async fetch(airportCode: string): Promise<ProviderResponse | null> {
    const debug = FLAGS.DEBUG;
    const start = Date.now();

    const proxyUrl = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/get-multi-wait-times`;

    try {
      const res = await fetch(proxyUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ airport: airportCode, provider: 'airport_official' }),
        signal: AbortSignal.timeout(TIMEOUT_MS),
      });

      if (!res.ok) {
        if (debug) console.log(`[airportSiteProvider] proxy returned ${res.status}`);
        return null;
      }

      const data = await res.json();
      if (debug) console.log(`[airportSiteProvider] latency=${Date.now() - start}ms`, data);

      if (data.waitTimeMinutes !== undefined && data.waitTimeMinutes !== null) {
        return {
          waitTimeMinutes: data.waitTimeMinutes,
          lastUpdatedISO: data.lastUpdatedISO || new Date().toISOString(),
          source: 'airport_official',
          confidence: data.confidence ?? 0.75,
          checkpointName: data.checkpointName,
          raw: data.raw,
        };
      }
      return null;
    } catch (err) {
      if (debug) console.log(`[airportSiteProvider] error latency=${Date.now() - start}ms`, err);
      return null;
    }
  },
};
